module.exports = __webpack_public_path__ + "img/information.5e60d6ab.svg";